import * as React from 'react';
import SelectSearchComponent from '../../../../../../common/components/SelectSearchComponent';
import {GROUP, GROUP_ERROR, GROUP_MAX_SIZE_FILE} from '../../../../../group/constants/LabelConstants';
import InputText from '../../../../../../common/components/InputText';
import * as InputTextTypes from '../../../../../../common/components/InputTextTypes';
import AssetsManager from '../../../../../../common/utils/AssetsManager';
import FileUploader from '../../../../../../common/components/FileUploader';
import {
    CommissionBankAccountFormDispatchProps,
    CommissionBankAccountFormStateProps,
} from '../../../../../group/types/mx/containers';
import {BankAccountDataState} from '../../../../../group/types/mx/components';
import {CommissionBankAccountFile, CommissionBankAccountFileType} from '../../../../../group/types/mx/types';
import {isEmpty} from '../../../../../../common/utils/ValidationUtils';
import {FileProps} from '../../../../../../common/types/components';
import {
    DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES
} from '../../../../../../common/constants/MimeTypeConstants';
import {COMMON} from '../../../../../../common/constants/LabelConstants';
import {GLOBAL, LOAN_APPLICATION_MX} from '../../../../../constants/LabelConstants';
import {downloadFileFromURL, getFileMimeTypeFromURL, getSafe} from '../../../../../../common/utils/GeneralUtils';

class CommissionBankAccountFormView extends React.Component<CommissionBankAccountFormStateProps
    & CommissionBankAccountFormDispatchProps, BankAccountDataState> {

    constructor(props) {
        super(props);
        this.state = {
            showErrors: false
        };
    }

    onPressSave = () => {
        this.setState({showErrors: true}, this.checkData);
    }

    dispatchError = (field: any, cond: (field: any) => boolean,
                     dispatch: (field: any, error: string) => void, error) => {
        if (cond(field)) dispatch(field, error);
    }

    checkData = () => {
        const {
            accountNumber, bankSelected, beneficiaryName, clabe,
            onChangeAccountNumber, onChangeBeneficiary, onChangeBank, onChangeClabe, onSave
        } = this.props;
        const fieldRequired: string = GROUP_ERROR.GROUP_FIELD_REQUIRED;
        const bankRequired: string = GROUP_ERROR.GROUP_REQUIRED_BANK;

        if (this.formHasNotError()) return onSave();
        this.dispatchError(bankSelected.value, val => val === null || isEmpty(val.value), onChangeBank, bankRequired);
        this.dispatchError(beneficiaryName.value, isEmpty, onChangeBeneficiary, fieldRequired);
        this.dispatchError(clabe.value, isEmpty, onChangeClabe, fieldRequired);
        this.dispatchError(accountNumber.value, field => !/^\d+$/.test(field), onChangeAccountNumber,
            GROUP_ERROR.GROUP_INVALID_BANK_ACCOUNT);
    }

    toBankAccountFile = (file, type: CommissionBankAccountFileType): CommissionBankAccountFile => ({
        url: file.preview,
        mimeType: file.type,
        fileType: type,
        hasError: false,
        content: file,
        isUploaded: false,
        name: file.name,
        size: file.size,
        lastModified: file.lastModified
    })

    onDropFile = (files: FileList, type: CommissionBankAccountFileType, section: string, error: string) => {
        const isSizeAllowed: boolean = !!files[0] && files[0].size <= GROUP_MAX_SIZE_FILE;
        const newError: string = isSizeAllowed ? error : COMMON.FILE_SIZE_NOT_ALLOWED;
        const file: CommissionBankAccountFile = isSizeAllowed ? this.toBankAccountFile(files[0], type) : null;
        if (type === CommissionBankAccountFileType.COMMISSION_ACCOUNT_STATUS_TYPE) {
            this.props.onDropFileAccount(file, newError);
        } else {
            this.props.onDropFileIdentification(file, newError);
        }
    }

    toFileProps = (file: CommissionBankAccountFile, id: string): FileProps => ({
        id, fileName: file.name, mimeType: file.mimeType,
        originalUrl: file.url, compressUrl: file.url, thumbnailUrl: file.url
    })

    onDeleteFile = (id: string, type: CommissionBankAccountFileType) => {
        this.props.onDeleteFile(id, type, GROUP_ERROR.GROUP_DOCUMENTS_REQUIRED);
    }

    formHasNotError = () => {
        const {
            bankSelected, accountNumber, beneficiaryName, clabe
        } = this.props;

        return !!bankSelected.value.value && !!accountNumber.value && !!beneficiaryName.value && !!clabe.value &&
            bankSelected.error === null && accountNumber.error === null && beneficiaryName.error === null &&
            clabe.error === null;
    }

    onDownload = (item) => {
        const type: string = !!item.mimeType ? item.mimeType : getFileMimeTypeFromURL(item.url);
        return downloadFileFromURL(item.url, item.name, type);
    }

    openFile = (item) => {
        window.open(item.originalUrl, '_blank');
    }

    render() {
        const btnStyle: string = 'btn btn-link btn-form border-0 h-100 pb-2';
        const {
            onCancel, bankSelected, banksList, onChangeBank, accountNumber, onChangeAccountNumber,
            beneficiaryName, clabe, dealerAccountStatusFile, dealerOfficialIdentificationFile,
            onChangeBeneficiary, onChangeClabe, loadExistCommissionBankAccount
        } = this.props;
        const {showErrors} = this.state;
        const bankAccountFileStatusAccount: CommissionBankAccountFile =
            !!dealerAccountStatusFile.value && dealerAccountStatusFile.value;
        const bankAccountFileOfficialIdentification: CommissionBankAccountFile =
            !!dealerOfficialIdentificationFile.value && dealerOfficialIdentificationFile.value;

        const accountFile: FileProps[] = bankAccountFileStatusAccount ?
            [this.toFileProps(bankAccountFileStatusAccount, 'commissionBankAccountFileStatusAccount')] : [];
        const identificationFile: FileProps[] = bankAccountFileOfficialIdentification ?
            [this.toFileProps(bankAccountFileOfficialIdentification, 'commissionBankAccountFileId')] : [];
        const textButton =  loadExistCommissionBankAccount ? GROUP.GROUP_UPDATE_LABEL : GROUP.GROUP_SAVE_LABEL;
        return (
            <div className="col-12 px-0 pt-5 pb-0">
                <div className="row">
                    <div className="col">
                        <InputText
                            label={GROUP.GROUP_ACCOUNT_NUMBER_FIELD_TITLE}
                            id="postalCode"
                            required={true}
                            type={InputTextTypes.NUMBER}
                            maxLength={15}
                            minLength={4}
                            hasError={showErrors}
                            labelError={accountNumber.error}
                            value={accountNumber.value}
                            onChange={onChangeAccountNumber}/>
                    </div>
                    <div className="col">
                        <SelectSearchComponent
                            customClass="no-min-height"
                            id="documentTypes"
                            label={GROUP.GROUP_BANK_TITLE}
                            placeholder={GLOBAL.SELECT}
                            value={bankSelected.value}
                            data={banksList}
                            required={true}
                            insertInput={true}
                            onChange={onChangeBank}
                            hasError={showErrors}
                            labelError={bankSelected.error}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <InputText
                            label={GROUP.GROUP_BENEFICIARY_NAME_TITLE}
                            id="postalCode"
                            required={true}
                            minLength={3}
                            hasError={showErrors}
                            labelError={beneficiaryName.error}
                            value={beneficiaryName.value}
                            onChange={onChangeBeneficiary}/>
                    </div>
                    <div className="col">
                        <InputText
                            label={GROUP.GROUP_CLABE_INTERBANK_TITLE}
                            id="postalCode"
                            type={InputTextTypes.NUMBER}
                            required={true}
                            maxLength={18}
                            minLength={18}
                            hasError={showErrors}
                            labelError={clabe.error}
                            value={clabe.value}
                            onChange={onChangeClabe}/>
                    </div>
                </div>
                {
                    !getSafe(() => bankAccountFileStatusAccount.name) ||
                    !getSafe(() => bankAccountFileOfficialIdentification.name) ?
                    <div className="row">
                        <div className="col">
                            <div className="row border-attention m-0 py-3 mb-4">
                                <div className="col-1 p-0 text-center">
                                    <img src={AssetsManager('/assets/images/common/attention-icon.svg')}
                                         alt="Attention"/>
                                </div>
                                <div className="col-11 p-0 input-text-enabled">
                                    {GROUP.GROUP_BANK_ACCOUNT_INFO}
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
                }
                <div className="row">
                    <div className="col d-flex">
                        <div className="mr-2">
                            {loadExistCommissionBankAccount && <div className="title-label">
                                {GROUP.GROUP_DEALER_ACCOUNT_STATUS_LABEL}
                            </div>}
                            <FileUploader
                                id="dealerAccountStatusFile"
                                type={CommissionBankAccountFileType.COMMISSION_ACCOUNT_STATUS_TYPE}
                                section={null}
                                required={false}
                                multiple={false}
                                accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                                label={GROUP.GROUP_DEALER_ACCOUNT_STATUS_LABEL}
                                onDrop={this.onDropFile}
                                onDelete={(id: string) =>
                                    this.onDeleteFile(id, CommissionBankAccountFileType.COMMISSION_ACCOUNT_STATUS_TYPE)
                                }
                                onClickThumbnail={file => this.openFile(file)}
                                uploadedFiles={accountFile}
                                hasError={this.state.showErrors}
                                labelError={' '}/>
                            {getSafe(() => dealerAccountStatusFile.value.url) &&
                            <div id="downloadOpt" className="link-details mt-2 text-center"
                                 onClick={() =>
                                     this.onDownload(
                                         dealerAccountStatusFile.value
                                     )}>
                                {LOAN_APPLICATION_MX.FILE_DOWNLOAD_DOCUMENT}
                            </div>
                            }
                        </div>
                        <div className="mr-2">
                            {loadExistCommissionBankAccount && <div className="ml-4 title-label">
                                {GROUP.GROUP_DEALER_OFFICIAL_IDENTIFICATION_LABEL}
                            </div>}
                            <FileUploader
                                id="dealerOfficialIdentificationFile"
                                type={CommissionBankAccountFileType.COMMISSION_OFFICIAL_IDENTIFICATION_TYPE}
                                section={null}
                                customClass="ml-4"
                                accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                                required={false}
                                multiple={false}
                                label={GROUP.GROUP_DEALER_OFFICIAL_IDENTIFICATION_LABEL}
                                onDrop={this.onDropFile}
                                onDelete={(id: string) =>
                                    this.onDeleteFile(
                                        id, CommissionBankAccountFileType.COMMISSION_OFFICIAL_IDENTIFICATION_TYPE
                                    )}
                                onClickThumbnail={file => this.openFile(file)}
                                uploadedFiles={identificationFile}
                                hasError={this.state.showErrors}
                                labelError={' '}/>
                            {getSafe(() => dealerOfficialIdentificationFile.value.url) &&
                            <div id="downloadOpt" className="link-details mt-2 text-center"
                                 onClick={() =>
                                     this.onDownload(
                                         dealerOfficialIdentificationFile.value
                                     )}>
                                {LOAN_APPLICATION_MX.FILE_DOWNLOAD_DOCUMENT}
                            </div>
                            }
                        </div>
                    </div>
                </div>
                <div className="row mb-6">
                    {showErrors && (dealerOfficialIdentificationFile.error || dealerAccountStatusFile.error) &&
                    <div className="col text-left form-text is-invalid">
                        <img className="ic mr-2" alt="warning"
                             src={AssetsManager('/assets/images/common/warning-icon.svg')}/>
                        {dealerOfficialIdentificationFile.error || dealerAccountStatusFile.error}
                    </div>}
                </div>
                <div className="col-12 pt-3 px-0 border-top">
                    <div className="d-flex justify-content-end">
                        <a className={`${btnStyle} text-secondary-lighten-5`}
                           onClick={() => onCancel()}>{GROUP.GROUP_CANCEL_LABEL}</a>
                        <a id="saveBtn" className={`${btnStyle} text-primary pr-0`} onClick={this.onPressSave}>
                            {textButton}
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default CommissionBankAccountFormView;
